// Patient.jsx
import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { PatientCard } from "./PatientCard";
import { Col, Row, Spinner } from "react-bootstrap";
import "./Patient.scss";
import { DeleteModal } from "../Modals/DeleteModal";
import { useDispatch, useSelector } from "react-redux";
import {
  deletePatient,
  setCurrentData,
  patientList,
} from "../../../redux/actions/dbactions/patientActions";
import { EditModal } from "./EditModal";
import { Header } from "../../Header";
import { Icon } from "@iconify/react/dist/iconify.js";

const Patient = ({ searchQuery }) => {
  const dispatch = useDispatch();
  const { patient, isLoading } = useSelector((state) => state.patientlist);
  const [show, setShow] = useState(false);
  const [editmodal, setEditmodal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedTitle, setSelectedTitle] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [selectedCountryId, setSelectedCountryId] = useState(null);

  useEffect(() => {
    dispatch(patientList());
  }, [dispatch, refresh]);

  const handleShow = (id, firstName, lastName) => {
    setShow(true);
    setSelectedId(id);
    setSelectedTitle(`${firstName} ${lastName}`);
  };

  const handleEditModal = (data) => {
    setEditmodal(true);
    dispatch(setCurrentData(data));
    setSelectedCountryId(data.addr_country_id);
  };

  const handleDelete = () => {
    dispatch(deletePatient(selectedId));
    setRefresh(!refresh); // Toggle to trigger useEffect
    setShow(false);
  };

  // Correctly access svcUserProfileList from the patient data
  let svcUserProfileList = [];
  if (patient && patient.usr && Array.isArray(patient.usr.svcUserProfileList)) {
    svcUserProfileList = patient.usr.svcUserProfileList;
  }

  // Adjusted filtering logic to match actual data structure
  const filteredPatients = svcUserProfileList.filter(
    (item) =>
      item.user_first_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.user_last_name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div>
      <Header
        pageTitle="Patient List"
        icon={<Icon icon="fa-solid:user-injured" />}
      />
      <div className="px-[0.75rem] sm:px-8 mt-4 flex items-center justify-between mb-3">
        <h5 className="text-base sm:text-[26px] w-full whitespace-nowrap m-0">
          My Patient List
        </h5>
        <div className="w-fit whitespace-nowrap">
          <Link
            to={`/dashboard/explore/add-patient`}
            className=" !text-xs sign_btn"
          >
            + Add New Patient
          </Link>
        </div>
      </div>
      {isLoading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <Row className="sm:px-4 m-0">
          {filteredPatients.length > 0 ? (
            filteredPatients.map((item, index) => (
              <Col className="mb-6" lg={4} md={6} key={item.svcuser_profile_id}>
                <PatientCard
                  data={item}
                  handleShow={() =>
                    handleShow(
                      item.svcuser_profile_id,
                      item.user_first_name,
                      item.user_last_name
                    )
                  }
                  handleEditModal={() => handleEditModal(item)}
                />
              </Col>
            ))
          ) : (
            <Col>
              <p className="text-center">No patients found</p>
            </Col>
          )}
        </Row>
      )}
      <DeleteModal
        handleDelete={handleDelete}
        show={show}
        handleClose={() => setShow(false)}
        selectedTitle={selectedTitle}
      />
      <EditModal
        show={editmodal}
        onHide={() => setEditmodal(false)}
        dispatch={dispatch}
        selectedCountryId={selectedCountryId}
        setSelectedCountryId={setSelectedCountryId}
        setRefresh={setRefresh}
        setEditmodal={setEditmodal}
      />
    </div>
  );
};

export default withRouter(Patient);
